import * as React from 'react'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import Loading from '../../components/Loading'
import FormButtons, { getOnSubmitWithCallback, SubmitAction, SubmitCallback } from './FormButtons'
import { useDispatch } from 'react-redux'
import { AxiosRequestConfig } from 'axios'
import useEntity from '../../hooks/useEntity'
import { AxiosPromiseAction } from '../../reducers'
import { EntityFormWrapperProps, EntityParams } from './Form'
import { SpringBootError } from '../../context/AxiosContext'

type Props<E = {}, V = {}> = EntityFormWrapperProps<E, V> & {
    getEntity: (id: string) => AxiosRequestConfig
    updateEntity: (id: string, values: V) => AxiosPromiseAction
    deleteEntity: (id: string) => AxiosPromiseAction
    getLockedSave?: (entity: E) => boolean
    getLockedDelete?: (entity: E) => boolean
}

export default function EditEntityForm<E, V>(props: Props<E, V>) {
    const dispatch = useDispatch()
    const [action, setAction] = useState<SubmitAction<V>>()
    const [callback, setCallback] = useState<SubmitCallback>()
    const { id } = useParams<EntityParams>()
    const [entity] = useEntity<E, string, SpringBootError, string>(id => props.getEntity(id), id)

    if (!entity.loaded) {
        return <Loading />
    }

    return (
        <props.form
            entity={entity}
            onSubmit={getOnSubmitWithCallback(dispatch, action, callback)}
            useFileContext={props.useFileContext}
            returnUrl={props.returnUrl}
        >
            <FormButtons<V>
                {...props}
                setAction={setAction}
                setCallback={setCallback}
                save={[(values: V) => props.updateEntity(id, values)]}
                lockedSave={props.getLockedSave?.(entity.data)}
                lockedDelete={props.getLockedDelete?.(entity.data)}
                delete={[() => props.deleteEntity(id), null, true]}
            />
        </props.form>
    )
}
